import React from 'react';
import { Table } from 'antd';
import moment from 'moment';
import cx from 'classnames';

import {
  ACHPaymentResponseModel,
  ACHPaymentsPagedResponseModel,
} from 'api/adminApiClient';

import styles from './UnprocessedPaymentsTable.module.less';

const pageSize = 12;

const columns = [
  {
    title: 'File Name',
    key: 'fileName',
    render: (record: ACHPaymentResponseModel) => (
      <span className="wrapped-text">{record.fileName}</span>
    ),
  },
  {
    title: 'Uploaded On',
    key: 'uploadedOn',
    render: (record: ACHPaymentResponseModel) =>
      moment.utc(record.uploadedOn).format('MM/DD/YYYY'),
  },
];

type Props = {
  isLoading: boolean;
  currentPage: number;
  selectedPaymentIds: string[];
  onPageChange: (page: number) => void;
  paymenetsData?: ACHPaymentsPagedResponseModel;
  onSelectPayment: React.Dispatch<React.SetStateAction<string[]>>;
};

export default function UnprocessedPaymentsTable(props: Props) {
  const {
    isLoading,
    paymenetsData,
    currentPage,
    onPageChange,
    selectedPaymentIds,
    onSelectPayment,
  } = props;

  const onRowSelection = (selectedRowKeys: React.ReactText[]) => {
    onSelectPayment(selectedRowKeys as string[]);
  };

  return (
    <Table
      className={cx(styles.table, 'custom-table')}
      pagination={{
        total: paymenetsData?.totalCount,
        pageSize,
        onChange: onPageChange,
        current: currentPage,
        showSizeChanger: false,
      }}
      columns={columns}
      rowSelection={{
        columnTitle: 'Select',
        columnWidth: '150px',
        hideSelectAll: true,
        // Keep the selection keys in the list even they don't exist in `dataSource`
        // in order to preserve selected rows on the different pages during pagination
        preserveSelectedRowKeys: true,
        selectedRowKeys: selectedPaymentIds,
        onChange: onRowSelection,
      }}
      dataSource={paymenetsData?.details}
      rowKey={(record) => record.id as string}
      loading={isLoading}
      locale={{
        emptyText: (
          <span>
            Congratulations! You do not have any unprocessed ACH payment files.
          </span>
        ),
      }}
    />
  );
}
